import "./Footer.css"

export default function Footer() {
    return <div className="Footer__container">
        <br />
        Made with 💜 at RIT
        <br />
        <a 
            className="Footer__link" 
            href="https://csh.rit.edu"
            rel="noreferrer"
            target="_blank"
        >csh.rit.edu</a>
    </div>
}